import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppShellComponent } from './app-shell/app-shell.component';
import { AppShellRoutingModule } from './app-shell-routing.module';
import { IonicModule } from '@ionic/angular';
import { OICommonModule } from '../common-components/common.module';
import { DefectsListComponent } from './defects-list/defects-list.component';
import { NgxPrintModule } from 'ngx-print';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslationLoaderFactory } from '@monorepo/services';

@NgModule({
  declarations: [AppShellComponent, DefectsListComponent],
  imports: [
    CommonModule,
    IonicModule,
    AppShellRoutingModule,
    OICommonModule,
    NgxPrintModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          const factory = new TranslationLoaderFactory(http);
          return factory.createForApp('oi-app');
        },
        deps: [HttpClient],
      },
    }),
  ],
  exports: [AppShellComponent],
})
export class AppShellModule {}
